import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {LiveMatchHandlerInterface} from "@/modules/match/interfaces";
import LiveMatchEvaluator from "@/modules/match/services/LiveMatchEvaluator";
import {LiveIncidentType, TickType} from "@/modules/match/types";
import {NeutralIncidentTypeEnum} from "@/modules/match/enums";
import {Match} from "@/modules/match/entity";

@injectable()
export default class NeutralLiveMatchHandler implements LiveMatchHandlerInterface {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  priority(): number {
    return 1000;
  }

  async onFinish(liveMatchEvaluator: LiveMatchEvaluator, tick: TickType) {
  }

  onIncident(liveMatchEvaluator: LiveMatchEvaluator, tick: LiveIncidentType): Promise<void> {
    return Promise.resolve(undefined);
  }

  async onTick(liveMatchEvaluator: LiveMatchEvaluator, tick: TickType): Promise<void> {
    if (tick.minute === 0) {
      await liveMatchEvaluator.triggerIncident(
        liveMatchEvaluator.createLiveIncident(
          await liveMatchEvaluator.createNeutralIncident(tick.match, NeutralIncidentTypeEnum.START)
        )
      );
    }

    if (tick.minute >= 90 && !tick.match.extraTime) {
      await liveMatchEvaluator.triggerIncident(
        liveMatchEvaluator.createLiveIncident(
          await liveMatchEvaluator.createNeutralIncident(tick.match, NeutralIncidentTypeEnum.END)
        )
      );

      if (!liveMatchEvaluator.needDecision) {
        liveMatchEvaluator.end();
        return;
      }

      if (this.isDecided(tick, liveMatchEvaluator.firstLegMatch)) {
        liveMatchEvaluator.end();
        return;
      }

      tick.match.extraTime = true;

      await liveMatchEvaluator.triggerIncident(
        liveMatchEvaluator.createLiveIncident(
          await liveMatchEvaluator.createNeutralIncident(tick.match, NeutralIncidentTypeEnum.START_EXTRA_TIME)
        )
      );
    }

    if (tick.minute >= 120 && tick.match.extraTime) {
      await liveMatchEvaluator.triggerIncident(
        liveMatchEvaluator.createLiveIncident(
          await liveMatchEvaluator.createNeutralIncident(tick.match, NeutralIncidentTypeEnum.END_EXTRA_TIME)
        )
      );

      if (!this.isDecided(tick, liveMatchEvaluator.firstLegMatch)) {
        await liveMatchEvaluator.triggerIncident(
          liveMatchEvaluator.createLiveIncident(
            await liveMatchEvaluator.createNeutralIncident(tick.match, NeutralIncidentTypeEnum.START_PENALTY)
          )
        );
      }
    }
  }

  private isDecided(tick: TickType, firstLegMatch?: Match) {
    if (!firstLegMatch) {
      return tick.match.homeGoals !== tick.match.awayGoals;
    }


    return (tick.match.homeGoals! + firstLegMatch.awayGoals!) !== (tick.match.awayGoals! + firstLegMatch.homeGoals!);
  }
}
